module.exports = __webpack_public_path__ + "img/bonuses1.29583350.png";